<template>
  <div>
    <label class="mb-0"><i class="fa fa-ticket-alt text-warning mr-1"></i> Voucher</label>
    <div class="d-flex position-relative">
      <span class="font-weight-bold text-nowrap" style="position: absolute; top: 7px; left: 12px">B -</span>
      <input id="voucherInput" placeholder="######" type="tel" class="form-control" @keyup.enter="addVoucher()" v-model="ref_voucher" :disabled="disabled" style="padding-left: 38px"/>
      <button class="btn ml-1 btn-info" style="width: 70px" @click="addVoucher" :disabled="disabled">
        <i class="fa fa-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ValidarVoucher",
  props: ['id_comanda', 'disabled'],
  data() {
    return {
      token: localStorage.getItem('key'),
      ref_voucher: '',
    }
  },

  methods: {
    addVoucher() {
      this.ref_voucher = this.ref_voucher ? this.ref_voucher.replace(/[^\d]/g, '') : '';

      if (!this.ref_voucher.trim() || isNaN(this.ref_voucher)) {
        this.$swal("Por favor informe apenas números no código do Voucher").then(() => {
          this.$helpers.focusElement('voucherInput');
        });

        return;
      }

      this.$store.state.load = "Buscando Voucher";
      const dados = {voucher: this.ref_voucher, is_produto: 'true', id_comanda: this.id_comanda || null}

      this.$http.post('voucher/validar/' + this.token, dados)
        .then(res => {
          this.$store.state.load = false;
          const data = res.data || {};

          if (data.result && data.dados && data.dados.valor) {
            this.ref_voucher = '';
            this.$emit('addVoucher', data.dados);

          } else {
            this.$swal(data.msg || 'Este Benefício não está disponível para esta venda!');
          }

        }, res => {
          this.$store.state.load = false;
          this.$swal(res.data ? res.data.msg || 'Erro temporário' : 'Erro temporário');
        });
    }
  },

  created() {
    this.$parent.$on('clearVoucher', () => {
      this.ref_voucher = '';
    });
  }
}
</script>

<style scoped>
</style>